import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import _ from "lodash";

import { BrowserMultiFormatReader, BarcodeFormat, DecodeHintType } from "@zxing/library";

import * as playerActions from "../../actions/playerActions";

let codeReader;

class BarcodeScanner extends React.PureComponent {

	constructor(props) {
		super(props);
		this.videoRef = React.createRef();
		autoBind(this);

		this.state = {
			errorMessage: ""
		};
	}

	componentDidMount() {
		let self = this;

		let formatHints = this.getPossibleFormatsHint(this.props.item.barcodeTypes);

		let hintsMap = new Map();

		if (formatHints.length > 0) {
			hintsMap.set(DecodeHintType.POSSIBLE_FORMATS, formatHints);
		}

		codeReader = new BrowserMultiFormatReader(hintsMap);
		codeReader.decodeOnceFromVideoDevice(undefined, this.videoRef.current).then((result) => {			

			let format = result.format;

			let resultEvent = {
				data: result.text,
				type: BarcodeFormat[format]
			};

			playerActions.hideBarcodeScanner(self.context.tree, resultEvent);

		}).catch((err) => {
			console.error(err);		
			this.setState({
				errorMessage: err.message
			});
		});
	}

	componentWillUnmount() {
		this.cleanupBarcodeScanner();
	}

	cleanupBarcodeScanner() {
		let videoElement = this.videoRef.current;

		if (videoElement) {
			videoElement.pause();
			videoElement.removeAttribute("src");
			videoElement.load();
		}

		if (codeReader) {
			codeReader.reset();
		}
	}

	getPossibleFormatsHint(barcodeTypes) {

		let hints = [];

		if (_.isString(barcodeTypes) && barcodeTypes.length > 0) {
			let arr = barcodeTypes.split(",");
			_.each(arr, (barcodeType) => {
				switch (barcodeType) {
					case "aztec":
						hints.push(BarcodeFormat.AZTEC);											
						break;
					case "code128":
						hints.push(BarcodeFormat.CODE_128);
						break;
					case "code39":
						hints.push(BarcodeFormat.CODE_39);
						break;
					case "code93":
						hints.push(BarcodeFormat.CODE_93);
						break;
					case "ean13":
						hints.push(BarcodeFormat.EAN_13);
						break;
					case "ean8":
						hints.push(BarcodeFormat.EAN_8);
						break;
					case "pdf417":
						hints.push(BarcodeFormat.PDF_417);
						break;
					case "qr":
						hints.push(BarcodeFormat.QR_CODE);
						break;
					case "upce":
						hints.push(BarcodeFormat.UPC_E);
						break;
					case "itf14":
						hints.push(BarcodeFormat.ITF);
						break;
					case "datamatrix":
						hints.push(BarcodeFormat.DATA_MATRIX);
						break;
					default:
						break;
				}
			});			
		}

		return hints;
	}

	render() {
		let errorMessage = (this.state.errorMessage) ? <div style={{ color: "white" }}>An error has occurred decoding the video stream: {this.state.errorMessage}</div> : null;
			
		return <div style={{position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
			<div className="barcode-scanner-container">
				<video ref={this.videoRef}></video>
			</div>
			{errorMessage}
		</div>;
	}
}

BarcodeScanner.contextTypes = {
	tree: PropTypes.baobab
};


export default branch({
}, BarcodeScanner);